import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React from "react";
import {Route, Routes} from "react-router-dom";
import CashLogs from "./clients_components/CashLogs";
import ClientLogs from "./clients_components/ClientLogs";
import GestionarReports from "./clients_components/GestionarReports";

import Menu from "./clients_components/Menu";
import NewReceipt from "./clients_components/NewReceipt";
import NewServiceReceipt from "./clients_components/NewServiceReceipt";
import PeriodicReports from "./clients_components/PeriodicReports";
import Receipt from "./clients_components/Receipt";
import Report from "./clients_components/Report";
import Reports from "./clients_components/Reports";
import ServiceReceipt from "./clients_components/ServiceReceipt";
import ServiceReceipts from "./clients_components/ServiceReceipts";
import Taxes from "./clients_components/Taxes";

export default function ClientOffice() {

	const NoOpPage = () => null;

	return (
		<Box
			sx={{
				width: "100%",
				height: "99%",
				position: "absolute",
				marginTop: 9,
			}}
		>
			<Grid container spacing={2} align="left">
				<Grid item xs={2}>
					<Menu/>
				</Grid>

				<Grid item xs={10}>
					<Routes>
						<Route
							path="new-receipt"
							element={
								<NewReceipt
								/>
							}
						/>
						<Route
							path="cash-and-cashiers"
							// element={
							//     <CashAndCashiers organization={organization} />
							// }
							element={<NoOpPage/>}
						/>
						<Route
							path="reports"
							element={<Reports/>}
						/>
						<Route
							path="reports/:pageNumber"
							element={<Reports/>}
						/>
						<Route
							path="cash-logs"
							element={<CashLogs/>}
						/>
						<Route
							path="cash-logs/:pageNumber"
							element={<CashLogs/>}
						/>
						<Route
							path="report"
							element={<Report/>}
							// element={<NoOpPage />}
						>
							<Route
								path=":reportId"
								// element={<Report />}
								element={<NoOpPage/>}
							/>
						</Route>
						<Route
							path="receipt"
							element={
								<Receipt
								/>
							}
						>
							<Route
								path=":receiptId"
								// element={
								//     <Receipt
								//         organizationAndUser={
								//             organizationAndUser
								//         }
								//     />
								// }
								element={<NoOpPage/>}
							/>
						</Route>
						<Route
							path="service-receipts"
							element={
								<ServiceReceipts
								/>
							}
						/>
						<Route
							path="service-receipts/:pageNumber"
							element={
								<ServiceReceipts
								/>
							}
						/>
						<Route
							path="new-service-receipt"
							element={
								<NewServiceReceipt
								/>
							}
						/>
						<Route
							path="service-receipt"
							element={<ServiceReceipt/>}
						>
							<Route
								path=":receiptId"
								element={<ServiceReceipt/>}
							/>
						</Route>
						<Route
							path="users"
							// element={<UserList role={role} />}
							element={<NoOpPage/>}
						/>
						{/*<Route*/}
						{/*    path="users/:pageNumber"*/}
						{/*    // element={<UserList role={role} />}*/}
						{/*    element={<NoOpPage />}*/}
						{/*/>*/}
						{/*<Route*/}
						{/*    path="edit-user/:userId"*/}
						{/*    // element={*/}
						{/*    //     <EditUser*/}
						{/*    //         organization={organization}*/}
						{/*    //         role={role}*/}
						{/*    //     />*/}
						{/*    // }*/}
						{/*    element={<NoOpPage />}*/}
						{/*/>*/}
						{/*<Route*/}
						{/*    path="new-user"*/}
						{/*    // element={*/}
						{/*    //     <NewUser*/}
						{/*    //         organization={organization}*/}
						{/*    //         role={role}*/}
						{/*    //     />*/}
						{/*    // }*/}
						{/*    element={<NoOpPage />}*/}
						{/*/>*/}
						<Route
							path="taxes"
							element={
								<Taxes
								/>
							}
						/>
						<Route path="logs" element={<ClientLogs/>}/>
						<Route
							path="gestionar-reports"
							element={<GestionarReports/>}
						/>
						<Route
							path="periodic-reports"
							element={<PeriodicReports/>}
						/>
					</Routes>
				</Grid>
			</Grid>
		</Box>
	);
}
